var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-list',{attrs:{"groups":_vm.channelGroups},on:{"add":_vm.addChannelGroup,"remove":_vm.removeChannelGroup,"edit":_vm.editChannelGroup,"copy":_vm.copyChannelGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }